import React from "react";

const GoTasteSearchBar = ({
  showModal,
  searchStep,
  navbarOnTop,
  defaultColor,
  searchIcon,
  searchString,
  locationLabel,
  onOpenSearch,
  onSearchToggle,
}) => {
  const fieldTone =
    navbarOnTop && !defaultColor
      ? "search-field-color-white"
      : "search-field-color-coffee";

  const getTriggerText = () => {
    if (showModal && searchStep === "results" && searchString?.trim()) {
      return searchString.trim();
    }

    if (locationLabel) {
      return `Search near ${locationLabel}`;
    }

    return "Search food, restaurants & more";
  };

  return (
    <button
      type="button"
      className={`${fieldTone} search-field d-flex align-items-center gotaste-search-trigger`}
      onClick={showModal ? onSearchToggle : onOpenSearch}
    >
      <span className="gotaste-search-trigger__text">{getTriggerText()}</span>
      <span className="btn btn-search gotaste-search-trigger__btn">
        <img src={searchIcon} alt="" className="searchIcon" />
      </span>
    </button>
  );
};

export default GoTasteSearchBar;
